module.exports = __webpack_public_path__ + "static/media/VideoJS.00103e88.eot";